import React, { Component } from 'react';
import ExpandCharacteristics from './../../../selections/characteristics/expand/ExpandCharacteristics';
import ExpandTime from './../../../selections/timeSelection/expand/ExpandTime';
import { Grid } from '@material-ui/core';

import './Styles.css'
class GISExpands extends Component {
    handleCloseMenu = () => {
        this.props.CloseMenu();
    }
    handleGis = () => {
        return (
            <Grid container >
                <div className="btnCloseContainer">
                    <button className="btnCloseMenu" onClick={this.handleCloseMenu}>
                        Cerrar Menú
                        </button>
                </div>
                {/* <Grid item xs={12}>
                    <ExpandFenomene onExtendGis={this.expandFenomene}
                        Seleccion={this.props.tipoSeleccion}
                    />
                </Grid> */}
                <Grid item xs={12}>
                    <ExpandCharacteristics
                        SelCaracteristicas={this.expanCharacteristics}
                        onOcupacion={this.handleOcupacion}
                        Seleccion={this.props.tipoSeleccion}
                    />
                </Grid>
                <Grid item xs={12}>
                    <ExpandTime
                        Seleccion={this.props.tipoSeleccion}
                    />
                </Grid>
            </Grid>
        )
    }
    render() {
        return (
            <Grid>
                {this.handleGis()}
            </Grid>
        )
    }
}
export default GISExpands;
